import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import { BillboardSeriesArtView } from './billboard_series_art_view';

function renderView(props) {
    const defaultProps = {
        series_art: null,
        loading_series_art: false,
        updating_series_art: false,
        uploading_series_art: false,
        onFetchSeriesArt: jest.fn(),
        onUpdateSeriesArt: jest.fn(),
        onUploadSeriesArt: jest.fn(),
    };
    return render(<BillboardSeriesArtView {...defaultProps} {...props} />);
}

describe('BillboardSeriesArtView (#482)', () => {
    it('fetches series art settings on mount', () => {
        const onFetchSeriesArt = jest.fn();
        renderView({ onFetchSeriesArt });
        expect(onFetchSeriesArt).toHaveBeenCalledTimes(1);
    });

    it('shows a loading indicator while the initial fetch is in flight', () => {
        const { container } = renderView({ loading_series_art: true, series_art: null });
        expect(container.querySelector('#series_art_toggle')).toBeNull();
    });

    it('renders the toggle off and the empty state when no series art is set', () => {
        const { getByText, getByRole } = renderView({
            series_art: { series_art_enabled: false, series_art_manual_url: null, current_series_art_url: null },
        });
        expect(getByRole('switch').getAttribute('aria-checked')).toBe('false');
        expect(getByText('No series art set yet')).not.toBeNull();
    });

    it('renders the current image and "From Planning Center" when using PCO art', () => {
        const { getByText, getByAltText } = renderView({
            series_art: {
                series_art_enabled: true,
                series_art_manual_url: null,
                series_art_pco_url: 'https://example.com/pco.jpg',
                current_series_art_url: 'https://example.com/pco.jpg',
            },
        });
        expect(getByAltText('Series art').src).toBe('https://example.com/pco.jpg');
        expect(getByText('From Planning Center')).not.toBeNull();
    });

    it('renders "Manually uploaded" and a clear-override control when a manual override is set', () => {
        const { getByText } = renderView({
            series_art: {
                series_art_enabled: true,
                series_art_manual_url: 'https://example.com/manual.jpg',
                series_art_pco_url: 'https://example.com/pco.jpg',
                current_series_art_url: 'https://example.com/manual.jpg',
            },
        });
        expect(getByText('Manually uploaded')).not.toBeNull();
        expect(getByText('Use Planning Center art instead')).not.toBeNull();
    });

    it('toggling calls onUpdateSeriesArt with the flipped value', () => {
        const onUpdateSeriesArt = jest.fn();
        const { getByRole } = renderView({
            onUpdateSeriesArt,
            series_art: { series_art_enabled: false, current_series_art_url: null },
        });
        fireEvent.click(getByRole('switch'));
        expect(onUpdateSeriesArt).toHaveBeenCalledWith({ series_art_enabled: true });
    });

    it('clearing the manual override calls onUpdateSeriesArt with an empty url', () => {
        const onUpdateSeriesArt = jest.fn();
        const { getByText } = renderView({
            onUpdateSeriesArt,
            series_art: {
                series_art_enabled: true,
                series_art_manual_url: 'https://example.com/manual.jpg',
                current_series_art_url: 'https://example.com/manual.jpg',
            },
        });
        fireEvent.click(getByText('Use Planning Center art instead'));
        expect(onUpdateSeriesArt).toHaveBeenCalledWith({ series_art_manual_url: '' });
    });
});
